<template>
  <div>
    <div class="searchContent" id="search">
      <div class="p_select select_day" >
        <div class="search_label">查询日期</div>
        <div @mouseover="onMouseOver('start')" @mouseleave="onMouseleave('start')">
          <el-date-picker
                  v-model="beginDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerDayOptions"
                  prefix-icon="''"
                  class="datepicker"
                  @change="getListData"
                  placeholder="选择开始日期">
          </el-date-picker>
          <i class="el-icon-date" ref="iconDateStart"></i>
        </div>
      </div>
      <div class="p_select select_day" >
        <div @mouseover="onMouseOver('end')" @mouseleave="onMouseleave('end')">
          <el-date-picker
                  v-model="endDate"
                  type="date"
                  value-format="yyyy-MM-dd"
                  :picker-options="pickerDayOptions"
                  prefix-icon="''"
                  class="datepicker"
                  @change="getListData"
                  placeholder="选择结束日期">
          </el-date-picker>
          <i class="el-icon-date" ref="iconDateEnd"></i>
        </div>
      </div>
      <div class="p_select">
        <el-select v-model="saId" clearable filterable placeholder="请选择服务顾问" @change="getListData">
          <el-option
                  v-for="item in orginUserArr"
                  :key="item.saId"
                  :label="item.saName"
                  :value="item.saId"
          ></el-option>
        </el-select>
      </div>
      <div class="p_select">
        <el-input placeholder="请输入档案ID" v-model="dossierId" clearable @change="getListData"></el-input>
      </div>
      <div class="p_select">
        <el-input placeholder="请输入VIN" v-model="frameNumber" clearable @change="getListData"></el-input>
      </div>
      <div class="p_select">
        <el-input placeholder="请输入车牌号" v-model="carNumber" clearable @change="getListData"></el-input>
      </div>
      <div class="p_select">
        <el-select v-model="inSceneStatus" clearable filterable placeholder="车主是否在场" @change="getListData">
          <el-option v-for="item in inSceneStatusArr" :key="item.inSceneStatus" :label="item.inSceneLabel"
            :value="item.inSceneStatus"></el-option>
        </el-select>
      </div>
      <div class="p_select">
        <el-select v-model="workStatus" clearable filterable placeholder="请选择状态" @change="getListData">
          <el-option v-for="item in workStatusArr" :key="item.workStatus" :label="item.workStatusName"
            :value="item.workStatus"></el-option>
        </el-select>
      </div>
      <div class="p_select" >
        <a class="search_btn" @click="getListData">查询</a>
        <a  class="add_btn" @click="downloadListData">导出</a>
      </div>
    </div>
    <div class="list_content">
      <el-table id="dossierlistData" :data="dossierlistData" style="width: 100%;padding-left: 24px;" :height="winHeight" :header-cell-style="getHeaderStyle" :cell-style="setRowStyle" header-cell-class-name="table_header">
        <el-table-column prop="dossierId" label="档案ID"></el-table-column>
        <el-table-column prop="carNumber" label="车牌"></el-table-column>
        <el-table-column prop="mile" label="里程" sortable></el-table-column>
        <el-table-column prop="frameNumber" label="车架号"></el-table-column>
        <el-table-column label="车主是否在场">
          <template slot-scope="scope">
            <span v-if="scope.row.inSceneStatus == 0 || scope.row.inSceneStatus == -1">-</span>
            <span v-if="scope.row.inSceneStatus == 3" style="color: #13ce66">SA带客在场</span>
            <span v-if="scope.row.inSceneStatus == 4" style="color: #13ce66">车主单独在场</span>
            <span v-if="scope.row.inSceneStatus == 5" style="color: #E6A23C">预检后SA开单</span>
            <span v-if="scope.row.inSceneStatus == 6" style="color: #E6A23C">SA开单后增项</span>
          </template>
        </el-table-column>

        <el-table-column prop="checkDay" label="日期"></el-table-column>



        <el-table-column label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.workStatus == 0" style="color: #ff4949">待处理</span>
            <span v-if="scope.row.workStatus == 10" class="test_ing">处理中</span>
            <span v-if="scope.row.workStatus == 1000" class="test_ed">处理完成</span>
          </template>
        </el-table-column>

        <el-table-column prop="saName" label="SA"></el-table-column>


        <el-table-column label="检测情况" width="180px">
          <template slot-scope="scope">
            <!-- <el-button size="small" @click="loadDossierDetail(scope.row)">查看详情</el-button> -->
            <a  @click="loadDossierDetail(scope.row)"><span class="test_detail">查看详情</span></a>
          </template>
        </el-table-column>

        <el-table-column label="分享溯源" width="180px">
          <template slot-scope="scope">
            <a  @click="shareDetail(scope.row)"><span class="test_detail">查看</span></a>
          </template>
        </el-table-column>

        <el-table-column label="二维码">
          <template slot-scope="scope">
            <img class="el-image__inner" :src="qr_demo" :alt="qr_demo_alt" @click="onClickReQr(scope.row)" />
          </template>
        </el-table-column>


      </el-table>

    <div class="pagination">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" background
        :current-page="pageNo" :page-sizes="[10, 20, 30, 40]" :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    </div>

    </div>

    <el-dialog title="全车检测二维码" :visible.sync="showQrCodeDialogRe" width="40%">
      <br />
      <div class="selectType" style="text-align:left;margin-left:10%">
        <p>请使用微信扫码二维码</p>
      </div>
      <br />
      <vue-qr id="qrcodeRe" class="qrcode" :text="shareUrlRe" :size="200"></vue-qr>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="showQrCodeDialogRe = false">关闭</el-button>
      </span>
    </el-dialog>

    <!--检测情况 & 报价信息-->
    <el-drawer
            title="检测情况 & 报价信息"
            left
            size="70%"
            :wrapperClosable="true"
            :visible.sync="showCarDetailInfo"
            direction="rtl">
      <div style="margin-left:24px;margin-right: 24px">
        <div class="info_list" style="text-align: left;">
          <el-button type="text" v-clipboard:copy="positionInfo.carNumber" v-clipboard:success="onCopy"
                     v-clipboard:error="onError">{{  positionInfo.carNumber  }} </el-button>
          <el-button type="text" v-clipboard:copy="frameNumber" v-clipboard:success="onCopy" v-clipboard:error="onError">
            {{  frameNumber  }} </el-button>
        </div>
        <el-table :data="DossierDetailList" border :header-cell-style="getHeaderStyle"
                  style="width: 100%; min-height:500px;float: right;">
          <el-table-column prop="positionId"   label="部位ID" width="80px"></el-table-column>
          <el-table-column prop="positionName"   label="部位名称" width="160px"></el-table-column>
          <el-table-column   label="检测情况" width="80px">
            <template slot-scope="scope">
              <span v-if="scope.row.tag * 1 == 10" style="color: #ff4d00">异常</span>
              <span v-else style="color: #15B628">正常</span>
            </template>
          </el-table-column>
          <el-table-column prop="diagnosis" align="left" label="检测结果"></el-table-column>


          <el-table-column   label="检测情况" width="180px">
            <template slot-scope="scope">
              <!--<el-button type="success" size="small" @click="loadCheckDetailInfo(scope.row)">查看</el-button>-->
              <a  @click="loadCheckDetailInfo(scope.row)"><span class="test_detail">查看详情</span></a>
            </template>
          </el-table-column>

        </el-table>
        <br />
      </div>
    </el-drawer>


    <!-- 部位检测情况对话框 -->
    <el-dialog :title="getCheckDetailTiltle" center :visible.sync="showPositionCheckDetail" width="80%" :close-on-click-modal="false">
      <el-divider></el-divider>
      <div>
        <div class="text_box">
          <div class="text_content">
            <!--部位说明-->
            <div class="option_explain">
              <p>部位说明：</p>
              <div>
                <span v-for="item of PositionCheckDetailData.textTemplates" :key="item.instructionText">{{  item.instructionText }}</span>
              </div>
            </div>
            <!--不维修风险-->
            <div class="risk_explain">
              <p>不维修风险：</p>
              <div><span v-for="item of PositionCheckDetailData.textTemplates" :key="item.warningText">{{  item.warningText }}</span></div>
            </div>
          </div>
          <div class="refer_to_content" v-if="this.PositionCheckDetailData.imageVersion > 0">
            <p>参考标准：</p>
            <div class="img_item" v-if="showVersion*1 === 2">
              <a  class="icon_box" @click="trunLeftStandImg" style="float: left;"><i class="el-icon-arrow-left"></i></a>
              <div class="img_list">
                <div class="img_flex_box" :style="{marginLeft:leftNum_stand+'px'}">
                  <div v-for="item of PositionCheckDetailData.standardImages" :key="item.index" class="img_flex_box_item">
                    <div class="label_img" v-if="item.statusType0 > 0">
                      <img :src="`${baseUrl}admin/manage/dossier/images/getVHCImg/${item.statusType0}`" />
                      <p>全新</p>
                    </div>
                    <div class="label_img" v-if="item.statusType10 > 0">
                      <img :src="`${baseUrl}admin/manage/dossier/images/getVHCImg/${item.statusType10}`" />
                      <div class="label_box">
                        <img src="../../assets/image/statusTypeImg10.png"  v-if="PositionCheckDetailData.positionCheckTag == 100" >
                        <span :style="PositionCheckDetailData.positionCheckTag == 100 ? '' : 'margin: 0 auto' ">正常</span>
                      </div>
                    </div>
                    <div class="label_img" v-if="item.statusType20 > 0">
                      <img :src="`${baseUrl}admin/manage/dossier/images/getVHCImg/${item.statusType20}`" />
                      <div class="label_box">
                        <img src="../../assets/image/statusTypeImg20.png" v-if="PositionCheckDetailData.positionCheckTag == 110">
                        <span :style="PositionCheckDetailData.positionCheckTag == 110 ? '' : 'margin: 0 auto' ">可使用</span>
                      </div>
                    </div>
                    <div class="label_img" v-if="item.statusType30 > 0">
                      <img :src="`${baseUrl}admin/manage/dossier/images/getVHCImg/${item.statusType30}`" />
                      <div class="label_box">
                        <img src="../../assets/image/statusTypeImg30.png" v-if="PositionCheckDetailData.positionCheckTag == 120">
                        <span :style="PositionCheckDetailData.positionCheckTag == 120 ? '' : 'margin: 0 auto' ">需处理</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <a  class="icon_box" @click="trunRightStandImg" style="float: right;"><i class="el-icon-arrow-right"></i></a>
            </div>

            <div class="version_first" v-else><img :src="PositionCheckDetailData.standardImage" ></div>
          </div>
        </div>
        <el-divider style="margin: 0 0 24px 0;"></el-divider>
        <div class="details_box">
          <div class="detail_info">
            <div class="detection">
              <p>检测情况：</p>
              <div>
                <div v-for="item of PositionCheckDetailData.textValueList" style="display: inline;" :key="item.id">
                  <div style="width:200px;display: inline-block;">
                    <span style="line-height: 20px;font-size: 12px;color: gray;">{{  item.headerLabel  }}: </span>
                    <span style="font-size: 24px;color: #E04066;font-weight: 500;">{{  item.valueText  }}{{  item.suffix  }}</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="harm">
              <p>诊断结果及危害：</p>
              <div>{{  PositionCheckDetailData.diagnosis  }}</div>
            </div>
            <div class="harm">
              <span>检测技师：</span>
              <span style="font-size: 24px;color: gray;font-weight: 500;">{{PositionCheckDetailData.workUserName}}</span>
            </div>
          </div>
          <div class="img_box">
            <p>影像检测：</p>
            <div class="img_item" v-if="aiPhoto.length > 0">
              <a  class="icon_box" @click="trunLeft" style="float: left;"><i class="el-icon-arrow-left"></i></a>
              <div class="img_list">
                <div class="img_flex_box" :style="{marginLeft:leftNum+'px'}">

                  <img v-for="item of aiPhoto" :src="item.imageUrl" :key="item.imageUrl"
                       @click="showImageDialog(item.imageUrl)"
                       style="width:200px;height: 150px;align-self: center;align-items: center;" />
                </div>
              </div>
              <a  class="icon_box" @click="trunRight(aiPhoto)" style="float: right;"><i class="el-icon-arrow-right"></i></a>
            </div>

            <div class="img_item" v-else>
              <a  class="icon_box" @click="trunLeft" style="float: left;"><i class="el-icon-arrow-left"></i></a>
              <div class="img_list">
                <div class="img_flex_box" :style="{marginLeft:leftNum+'px'}">

                  <div v-if="videoList.length > 0">
                    <div v-for="item of videoList" :src="item.imageUrl" :key="item.videoId"
                         style="width:200px;height: 150px;align-self: center;align-items: center;margin-right: 16px">
                      <video :src="item.playAddress" controls="controls" class="video-player vjs-custom-skin" style="width: 200px;height: 150px;">
                        您的浏览器不支持 video 标签。
                      </video>
                    </div>
                  </div>

                  <img v-for="item of PositionCheckDetailData.imageValueList" :src="item.imageUrl" :key="item.imageUrl"
                       @click="showImageDialog(item.imageUrl)"
                       style="width:200px;height: 150px;align-self: center;align-items: center;" />
                </div>
              </div>
              <a  class="icon_box" @click="trunRight(PositionCheckDetailData.imageValueList)" style="float: right;"><i class="el-icon-arrow-right"></i></a>
            </div>


          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="查看图片" center :visible.sync="showBigImage" width="700px" :close-on-click-modal="true">
      <div style="display: flex;flex-wrap: wrap;flex-direction: row;">
        <img :src="showBigImageUrl"
             style="width:640px;height: 480px;margin: 3px auto;border:1px solid #409EFF;align-self: center;align-items: center;" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="showBigImage = false">关闭窗口</el-button>
      </span>
    </el-dialog>


    <el-drawer
            title="分享溯源"
            left
            size="82%"
            :wrapperClosable="true"
            :visible.sync="showshareInfo"
            @opened="showSeeksGraph"
            direction="rtl">
      <div>
        <div style="height:calc(100vh - 100px);">
          <RelationGraph
                  ref="seeksRelationGraph"
                  :options="graphOptions"
                  :on-node-click="onNodeClick"
                  :on-line-click="onLineClick"
          />
        </div>
      </div>
    </el-drawer>

  </div>


</template>

<script>
import net from "../../assets/js/public";
import XLSX from "xlsx";
import FileSaver from "file-saver";
import vueQr from "vue-qr";
import Vue from 'vue'
import VueClipboard from 'vue-clipboard2'
import waterfall from 'vue-waterfall2'
import RelationGraph from 'relation-graph'
Vue.use(VueClipboard)
Vue.use(waterfall)
export default {
  name: "dossierManager",
  components: {
    vueQr,RelationGraph
  },
  data() {
    return {
      dossierId: '',
      carNumber: '',
      // frameNumber: '',
      orgId: '',
      orgArr: [],
      workStatus: '',
      workStatusArr: [
        { workStatus: 0, workStatusName: '待处理' },
        { workStatus: 10, workStatusName: '处理中' },
        { workStatus: 1000, workStatusName: '处理完成' },
      ],
      inSceneStatus: '',
      inSceneStatusArr: [
        { inSceneStatus: 0, inSceneLabel: '全部' },
        { inSceneStatus: 3, inSceneLabel: 'SA带客在场' },
        { inSceneStatus: 4, inSceneLabel: '车主单独在场' },
        { inSceneStatus: 5, inSceneLabel: '预检后SA开单' },
        { inSceneStatus: 6, inSceneLabel: 'SA开单后增项' },
      ],
      pageNo: 1,
      pageSize: 10,
      total: 0,
      dossierlistData: [],
      winHeight: '220',
      saId:'',
      orginUserArr:[],

      qr_demo: require("../../assets/image/Group_27.png"),
      qr_demo_alt: "点击展示二维码",
      showQrCodeDialogRe: false,
      shareUrlRe: '',
      disCheckOrg: false,

      pickerDayOptions: { // 按天 当天、当月可选
        disabledDate(time) {
          return time.getTime() > Date.now() + 1 * 24 * 60 * 60 * 1000;
        }
      },
      beginDate:'',
      endDate:'',


      DossierDetailList: [],
      ignoreUnQuote: false,
      showCarDetailInfoReadOnly: '',
      showCarDetailInfo: false,
      positionInfo: [],
      frameNumber: '',
      showFinshBtn: false,

      showPositionCheckDetail: false,
      getCheckDetailTiltle: '',
      PositionCheckDetailData: [],

      leftNum:0,
      showBigImageUrl : '',
      showBigImage : false,

      videoList:[], //检测视频
      imgList:[],


      showshareInfo: false,
      currentCase: '纵向树状图谱',
      isShowCodePanel: false,
      graphOptions: {
        "backgrounImageNoRepeat": true,
        "defaultNodeBorderWidth": 2,
        "defaultLineShape": 4,
        "defaultNodeShape": 1,
        "defaultNodeWidth": "120",
        "defaultJunctionPoint": "tb",
        "defaultNodeColor": "rgba(57, 167, 253, 1)",
        "defaultLineColor": "rgba(78, 75, 75, 1)",
        "defaultNodeBorderColor": "#58D5FD",
        "layouts": [
          {
            "label": "中心",
            "layoutName": "tree",
            "layoutClassName": "seeks-layout-center",
            "defaultJunctionPoint": "border",
            "defaultNodeShape": 0,
            "from": "left"
          }
        ],
        "defaultNodeHeight": "60"
      },

      graph_json_data:'',

      // VHC 版本的参考标准 图片
      baseUrl: net.baseUrl,
      leftNum_stand: 0,
      showVersion:'',

      aiPhoto: [], //AI图片


    }
  },
  created() {
    let signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
    if (signInfo.orgId > 0) {
      this.orgId = signInfo.orgId
    }

    let obj = new Date();
    let month = obj.getMonth() + 1;
    let day = obj.getDate();
    if (month < 10) month = "0" + month;
    if (day < 10) day = "0" + day;
    this.beginDate = obj.getFullYear() + "-" + month + "-" + day;

    let after = new Date(new Date().getTime() + 24 * 60 * 60 * 1000)//后一天
    let afterMonth = after.getMonth() + 1;
    if (afterMonth < 10) afterMonth = "0" + afterMonth;
    let afterDay = after.getDate()
    if (afterDay < 10) afterDay = "0" + afterDay;
    this.endDate = after.getFullYear() + "-" + afterMonth + "-" + afterDay;


    this.querySaList()
    this.getListData()
  },
  methods: {
    onMouseOver(item) {
      if(item == 'start'){
        this.$refs.iconDateStart.style.display = 'none';
      }else {
        this.$refs.iconDateEnd.style.display = 'none';
      }
    },
    onMouseleave(item) {
      if(item == 'start'){
        this.$refs.iconDateStart.style.display = 'block';
      }else {
        this.$refs.iconDateEnd.style.display = 'block';
      }
    },
    getHeaderStyle() {
      return "background-color:#F3F7FB; color: #364556; text-align: left;font-size: 14px;height: 48px;font-weight: 500;font-family: 'PingFang SC';";
    },
    setRowStyle(row, column, rowIndex, columnIndex) {
      return 'font-family: PingFang SC;font-style: normal;color: #0D0E12;font-weight: 500;font-size: 14px;'
    },
    // 复制成功时的回调函数
    onCopy(e) {
      net.message(this, "内容已复制到剪切板！", "success");
    },
    // 复制失败时的回调函数
    onError(e) {
      net.message(this, "抱歉，复制失败！", "warning");
    },
    // 删除线
    delLine({ row, rowIndex, }) {
      if (row.makeSureResult * 1 == 101) return 'del_line'
    },
    trunRight(imageValueList){
      let dataLength = imageValueList.length
      let maxLeft = -150 * dataLength // -120
      let leftNum = this.leftNum
      leftNum = leftNum - 200 // -40
      if(maxLeft < leftNum){
        this.leftNum = leftNum
      }
    },
    trunLeft(){
      let leftNum = this.leftNum
      leftNum = leftNum + 200 > 0 ? 0 : leftNum + 200
      this.leftNum = leftNum
    },
    trunRightStandImg(){
      let maxLeft = -150 * 3
      let leftNum_stand = this.leftNum_stand
      leftNum_stand = leftNum_stand - 200 // -40
      if(maxLeft < leftNum_stand){
        this.leftNum_stand = leftNum_stand
      }
    },
    trunLeftStandImg(){
      let leftNum_stand = this.leftNum_stand
      leftNum_stand = leftNum_stand + 200 > 0 ? 0 : leftNum_stand + 200
      this.leftNum_stand = leftNum_stand
    },
    // 获取SA
    querySaList() {
      net.request("admin/manage/report/getSAByOrg", "post").then(res => {
        if (res.code === 0) {
          this.orginUserArr = res.data;
        } else {
          net.message(this, "获取数据失败", "warning");
        }
      });
    },
    getListData(item) {
      const params = {
        dossierId: this.dossierId || null,
        carNumber: this.carNumber,
        frameNumber: this.frameNumber,
        saId: this.saId || null,
        pageNo: item && item.changeNo? this.pageNo : 1, //判断是否从第一页查询
        pageSize: this.pageSize,
        workStatus: this.workStatus,
        inSceneStatus: this.inSceneStatus || 0,
        beginDate: this.beginDate,
        endDate: this.endDate,
      }
      net.request("admin/manage/dossier/getOrgDossierSet", "post", null, params).then(res => {
        if (res.code === 0) {
          net.message(this, res.msg, "success");
          this.dossierlistData = res.data.rows
          this.total = res.data.total
          const windiwHight = document.documentElement.clientHeight || document.body.clientHeight // 可视屏幕高度
          this.winHeight = windiwHight - 228
        } else {
          net.message(this, res.msg, "warning");
        }
      });

    },
    onClickReQr(row) {
      const args = JSON.parse(sessionStorage.getItem("signInfo"))
      const dossierId = row.dossierId
      const shareUserId = args.id
      const shardKey = row.shardKey
      const shareType = row.showVersion

      const url = 'https://xcx-report.4s.epicas.cn/report?dossierId=' + dossierId + '&shareType=' + shareType + '&shareUserId=' + shareUserId + '&shardKey=' + shardKey
      this.shareUrlRe = url
      this.showQrCodeDialogRe = true;
    },

    //查看检测详情
    loadDossierDetail(row, readOnly = false) {
      this.DossierDetailList = []
      this.ignoreUnQuote = false;
      this.showCarDetailInfoReadOnly = readOnly;
      this.showVersion = row.showVersion
      const params = {
        dossierId: row.dossierId
      }
      net.request("admin/manage/dossier/loadDossierDetail", "post", params).then(res => {
        if (res.code === 0) {
          this.showCarDetailInfo = true
          this.positionInfo = res.data
          let positionInfoList = res.data.positionInfoList
          if (positionInfoList) {
            positionInfoList.forEach(item => {
              item.money = (item.money / 100).toFixed(2)
            })
          }
          this.DossierDetailList = positionInfoList
          this.frameNumber = res.data.frameNumber ? res.data.frameNumber : "-"
          this.showFinshBtn = true
        } else {
          net.message(this, res.msg, "warning");
        }
      });
    },
    //查看部位检测详情
    loadCheckDetailInfo(row) {
      const params = {
        dossierId: this.positionInfo.dossierId,
        positionId: row.positionId,
      }
      net.request("admin/manage/dossier/loadCheckDetail", "post", params).then(res => {
        let aiPhotoIdList = row.aiPhotoIdList
        if (res.code === 0) {
          this.showPositionCheckDetail = true
          this.getCheckDetailTiltle = res.data.positionName + ' 检测情况'
          if (res.data.imageVersion > 0) {
            let url2 = net.baseUrl+'admin/manage/image/getStandardImage/' + row.positionId + "/" + res.data.imageVersion + "/" + this.positionInfo.orgId;
            res.data.standardImage = url2
          }
          res.data.imageValueList.forEach(item => {
            let url = net.baseUrl+'admin/manage/image/getImg/' + item.valueText;
            item.imageUrl = url
          })
          let aiPhoto = []
          if(aiPhotoIdList && aiPhotoIdList.length > 0){
            aiPhotoIdList.forEach(item => {
              aiPhoto.push({
                imageUrl: net.baseUrl+'admin/manage/image/loadAuditAiPhoto/'+item
              })
            })
            this.leftNum = 0
          }
          let videoValueList = res.data.videoValueList
          if(videoValueList.length > 0){
            this.getVideoDetail(videoValueList)
          }else {
            this.videoList = []
          }
          this.PositionCheckDetailData = res.data
          this.aiPhoto = aiPhoto


        } else {
          net.message(this, res.msg, "warning");
        }
      });
    },
    // 查询检测视频
    getVideoDetail(item){
      let videoValueList = item
      let videoList = []
      let imgList = this.PositionCheckDetailData.imageValueList
      for(let i = 0; i < videoValueList.length; i++){
        let videoId = videoValueList[i].videoId
        let data = ''
        net.request("admin/manage/video/getVideoPlayInfo", "post", {videoId: videoId}).then(res => {
          if (res.code === 0){
            data = res.data
            videoList.push(data)
            this.videoList = videoList

          }
        })
      }
      this.imgList = imgList
    },
    // 点击图片查看大图
    showImageDialog(url) {
      this.showBigImageUrl = url;
      this.showBigImage = true
    },



    // 分享溯源
    shareDetail(row){
      const params = {
        dossierId: row.dossierId,
      }
      net.request("admin/manage/share/dossier", "post", params).then(res => {
        if (res.code === 0) {
          if(res.data){
            this.showshareInfo = true
            let nodes = res.data.nodes
            // nodes.forEach(item => {
            //   item['borderWidth'] = 1,
            //           item['nodeShape'] = 1,
            //           item['width'] = 120,
            //           item['height'] = 60
            // })
            const graph_json_data = {
              rootId: 'a',
              nodes: nodes,
              lines:res.data.lines,
            }
            this.graph_json_data = graph_json_data
          }else {
            net.message(this, "暂无访问数据", "warning");
          }

        } else {
          net.message(this, res.msg, "warning");
        }
      });
    },
    showSeeksGraph(){
      let graph_json_data = this.graph_json_data
      this.$refs.seeksRelationGraph.setJsonData(graph_json_data, (graphInstance) => {
        // 这些写上当图谱初始化完成后需要执行的代码
      });
    },

    onNodeClick(nodeObject, $event) {
      console.log('onNodeClick:', nodeObject);
    },
    onLineClick(lineObject, linkObject, $event) {
      console.log('onLineClick:', lineObject);
    },


    handleSizeChange(val) {
      this.pageSize = val;
      this.getListData()
    },
    handleCurrentChange(val) {
      this.pageNo = val
      this.getListData({changeNo: true})
    },


    //监听键盘Esc按键事件
    handleKeyup(event){
      let signInfo = JSON.parse(sessionStorage.getItem("showInfo"));
      let self = this;
      const e = event || window.event || arguments.callee.caller.arguments[0]
      if(!e) return
      if (e.keyCode == 27) {
        let routeNmae = self.$route.name
        if(routeNmae != 'OperationDataStatistics' && signInfo.active_tab == '3'){
          e.stopImmediatePropagation();
          self.$router.replace({ name: 'OperationDataStatistics' })
        }
      }
    },



    // 导出
    downloadListData(){
      if (this.beginDate === '' || this.beginDate === null || this.endDate === "" || this.endDate === null ) {
        net.message(this, "请选择日期区间", "warning");
        return;
      }
      const params = {
        id: this.dossierId || null,
        carNumber: this.carNumber,
        orgId: this.orgId,
        saId: this.saId || null,
        workStatus: this.workStatus,
        inSceneStatus: this.inSceneStatus || 0,
        beginDate: this.beginDate,
        endDate: this.endDate,
      }
      net.request("admin/manage/dossier/getOrgDossierSetExport", "post", {orgId: this.orgId}, params).then(res => {
        if (res.code === 0) {
          this.dossierlistData = res.data
          setTimeout(() => {

            var wb = XLSX.utils.table_to_book(document.querySelector('#dossierlistData'));
            var wbout = XLSX.write(wb, {
              bookType: "xlsx",
              bookSST: true,
              type: "array"
            });
            try {
              FileSaver.saveAs(
                      new Blob([wbout], { type: "application/octet-stream" }),
                      "检测档案.xlsx"
              );
            } catch (e) {
              if (typeof console !== "undefined") console.log(e, wbout);
            }


            this.getListData()
          }, 2000);
        } else {
          net.message(this, res.msg, "warning");
        }
      });
    },



  },
  mounted() {
    window.addEventListener('keyup',this.handleKeyup)
  },
  beforeDestroy() {
    window.removeEventListener('keyup',this.handleKeyup)
  }
};
</script>

<style lang='less' scoped>

.searchContent {
  background: #fff;
  margin: 24px 0px 0 24px;
  padding-top: 24px;
  // display: flex;
  // flex-direction: row;

  /*.el-input--suffix {*/
  /*width: 200px;*/
  /*margin-right: 20px;*/
  /*}*/
  .p_select {
    // width: 160px;
    display: flex;
    // margin-right: 20px;
    padding: 0 0 24px 24px;
    font-size: 12px;
    float: left;
    .search_label{
      font-family: 'PingFang SC';
      font-style: normal;
      margin-right: 12px;
      font-weight: 500;
      font-size: 14px;
      line-height: 40px;
      color: #787E86;
      white-space:nowrap
    }

    .el-input , .el-select{
      width: 160px;
    }
  }

    .search_btn {
      width: 76px;
      height: 36px;
      line-height: 36px;
      background: #2B54FC;
      box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
      border-radius: 4px;
      color: #FFFFFF;
      font-size: 14px;
    }
  .add_btn {
    width: 76px;
    height: 36px;
    margin-left: 10px;
    line-height: 36px;
    background: rgba(148, 170, 204, 0.08);
    border: 1px solid #2B54FC;
    border-radius: 4px;
    font-size: 14px;
    color: #2B54FC;
  }
}
.list_content {
  margin-left: 24px;
  background: #fff;
  padding-right: 24px;
}

.pagination {
  position: relative;
  margin-top: 10px;
  height: 36px;

  .el-pagination {
    position: absolute;
    right: 24px;

    .el-pager li:not(.disabled) {
      .active {
        background: #009688 !important;
      }
    }
  }
}

.el-pagination.is-background .el-pager li:not(.disabled).active {
  background: #009688;
}

// 检测详情弹窗
.text_box {
  overflow: hidden;
  .text_content {
    width: 50%;
    float: left;
    p {
      font-size: 16px;
      color: #0D0E12;
      margin-bottom: 16px;
    }
    div{
      font-size: 14px;
      color: #787E86;
      margin-bottom: 32px;
    }
    .risk_explain {
      margin-bottom: 64px;
    }
  }
  .refer_to_content {
    width: 46%;
    float: right;
    p {
      font-size: 16px;
      color: #0D0E12;
      margin-bottom: 16px;
    }
    /*普通版本*/
    .version_first {
      height: 210px;
      border-radius: 5px;
      overflow: hidden;
      img {
        height: 100%;
      }
    }
    /*VHC版本*/
    .img_item {
      height: 181px;
      background: #F6F8FB;
      border-radius: 6px;
      display: flex;
      overflow: hidden;
      .icon_box {
        width: 36px;
        height: 36px;
        display: block;
        background: rgba(255, 255, 255, 0.08);
        border: 1px solid #E3E7ED;
        border-radius: 4px;
        text-align: center;
        line-height: 36px;
        margin: 72px 9px;

      }
      .img_list {
        width: calc(100% - 72px);
        float: left;
        margin: 11px 0;
        overflow: hidden;
        .img_flex_box {
          height: 100%;
          display: flex;
          .img_flex_box_item{
            display: flex;
            .label_img {
              text-align: center;
              img {
                height: 140px;
                margin-right: 16px;
                border-radius: 5px;
                overflow: hidden;
              }
              .label_box {
                height: 20px;
                display: flex;
                line-height: 20px;
                img {
                  width: 20px;
                  height: 20px;
                  margin-left: 30%;
                  margin-right: 4px;
                }

              }
              /*p {
                font-size: 14px;
                line-height: 20px;
              }*/
            }

          }
        }
      }
    }
  }
}
.details_box {
  overflow: hidden;
  .detail_info {
    width: 35%;
    float: left;
    p {
      font-size: 16px;
      color: #0D0E12;
      margin-bottom: 16px;
    }
    div{
      font-size: 14px;
      color: #787E86;
      margin-bottom: 32px;
    }
    .detection {
      margin-bottom: 32px;
      div{
        display: flex;
        flex-direction: column;
        margin-bottom: 4px;
      }
    }
  }
  .img_box {
    width: 60%;
    float: right;
    p {
      font-size: 16px;
      color: #0D0E12;
      margin-bottom: 16px;
    }
    .img_item {
      height: 181px;
      background: #F6F8FB;
      border-radius: 6px;
      display: flex;
      overflow: hidden;
      .icon_box {
        width: 36px;
        height: 36px;
        display: block;
        background: rgba(255, 255, 255, 0.08);
        border: 1px solid #E3E7ED;
        border-radius: 4px;
        text-align: center;
        line-height: 36px;
        margin: 72px 9px;

      }
      .img_list {
        width: calc(100% - 72px);
        float: left;
        margin: 11px 0;
        overflow: hidden;
        .img_flex_box {
          display: flex;
          img {
            height: 100%;
            margin-right: 16px;
          }
        }
      }
    }
  }
}


.test_ing {
  background: #29D3BF;
  width: 60px;
  height: 24px;
  text-align: center;
  display: block;
  border-radius: 14px;
  font-weight: 500;
  font-size: 11px;
  line-height: 24px;
  color: #FFFFFF;
}
.test_ed {
  background: #ABB2BB;
  width: 60px;
  height: 24px;
  text-align: center;
  display: block;
  border-radius: 14px;
  font-weight: 500;
  font-size: 11px;
  line-height: 24px;
  color: #FFFFFF;
}
.test_detail {
  background: rgba(148, 170, 204, 0.08);
  border: 1px solid #E3E7ED;
  border-radius: 14px;
  width: 60px;
  height: 24px;
  text-align: center;
  display: block;
  font-weight: 500;
  font-size: 11px;
  line-height: 24px;
  color: #364556;
}

.select_box {
  text-align: left;
  margin-bottom: 10px;

  .select_title {
    display: inline-block;
    width: 100px;
    text-align: right;
    margin-right: 20px;
  }
}

.el-image__inner {
  width: 32px;
  line-height: 1;
  text-align: center;
  vertical-align: bottom;
}
/deep/ .table_header {
  background: #F3F7FB !important;
  color: #364556;
  // height: 48px !important;
  // border: 1px solid #E3E7ED;
}

.el-table__footer-wrapper, .el-table__header-wrapper {
  margin-left: 24px;
  height: 48px;

}
.el-table--scrollable-y .el-table__body-wrapper {
  margin-left: 24px;
}

/*.el-table {
  /deep/ tbody tr:hover>td,/deep/ tbody tr.hover-row>td {
    background: #FFFFFF;
    box-shadow:
            30px 10px 25px 0px rgba(127, 133, 154, 0.16),
            -56px 0px 10px 0px #fff,
            0px 5px 36px 0px rgba(127, 133, 154, 0.16);
  }
}*/

</style>
